import React from 'react';

import {
  clubsCategoriesQuery,
  clubsProductsQuery,
} from '../../../../../../store/managementAnalysisDetails/selector';
import { DynamicProductTable } from '../../DynamicProductTable';
import { ProductTableProps } from '../../DynamicProductTable/constants';

import { getClubsFilters, tableHead } from './constants';
import ProductItem from './item';

export const ClubesTable = (props: ProductTableProps) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={clubsProductsQuery}
      productsFiltersGetter={getClubsFilters}
      productCategoryQuery={clubsCategoriesQuery}
      tableHeadItems={tableHead}
      tabletColumns={4}
      mobileFields={[
        { key: 'customerNormalized', label: 'Cliente' },
        { key: 'assetNormalized', label: 'Ativo' },
        { key: 'positionDateNormalized', label: 'Data da cota' },
        { key: 'currentQuoteValueNormalized', label: 'Valor da cota atual' },
        { key: 'units', label: 'Qtde. cotas' },
        { key: 'grossValueNormalized', label: 'Valor bruto' },
        { key: 'netValueNormalized', label: 'Valor líquido' },
      ]}
    />
  );
};
